import styled from 'styled-components';
import { AspectRatioVideoContainer } from './AspectRatioVideoContainer';

export const SquareVideoContainer = styled(AspectRatioVideoContainer).attrs({ heightRatio: 100 })``;
